import { Component, OnInit, Input, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { UserManager } from 'src/app/Services/UserManager/user-manager';
import { AngularFireDatabase } from '@angular/fire/database';
import { Message, ConversationMeta, Member } from 'src/app/Models/conversation.interface'
import {Observable, Subject} from 'rxjs' 
import { Subscription } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { Profile } from 'src/app/Models/profile.interface';
import { EmailNotification } from 'src/app/Models/Notify.interface'
import { ScrollService } from 'src/app/Services/ScrollManager/scroll.service';
import { trigger, state, transition, animate, style} from '@angular/animations'
import { AngularFirestore , AngularFirestoreDocument, AngularFirestoreCollection} from '@angular/fire/firestore';
import 'firebase/firestore';
import { AUTOREPLIES, NOTIFY, PROFILES } from 'src/Constants';
import { AutoReply } from 'src/app/Models/autoreply.interface';
import { Question } from 'src/app/Models/question.interface';
import { LanguageSwitchService } from 'src/app/Services/LanguageSwitch/language-switch.service';
import { Supplement } from 'src/app/Models/supplemental.interface';


import _ from 'lodash';


@Component({
  selector: 'app-single-message',
  templateUrl: './single-message.component.html',
  styleUrls: ['./single-message.component.scss', '../../templates/question-template/svg.scss'],
  animations: [
  trigger('confirmationTrigger', [
      state('void', style({  opacity: 0, display: 'none', transform: 'scale(0)'})),
      state('show', style({  opacity: 1, display: '*',transform: 'scale(1)'})),
      transition('void => *',[ animate('300ms ease-in-out')]),
      transition('* => void',[ animate('300ms ease-in-out')]),
    ]),
    trigger('claimTrigger', [
      state('void', style({  opacity: 0, display: 'none', transform: 'scale(0)'})),
      state('show', style({  opacity: 1, display: '*', transform: 'scale(1)'})),
      transition('void => *',[ animate('300ms ease-in-out')]),
      transition('* => void',[ animate('300ms ease-in-out')]),

    ]),
    trigger('auto', [
      state('void', style({  opacity: 0, display: 'none', transform: 'scale(0)'})),
      state('show', style({  opacity: 1, display: '*', transform: 'scale(1)'})),
      transition('void => *',[ animate('300ms ease-in-out')]),
      transition('* => void',[ animate('300ms ease-in-out')]),

    ]),
    trigger('rotate', [
      state('void', style({ transform: 'rotateZ(0)'})),
      state('show', style({ transform: 'rotateZ(180deg)'})),
      transition('void => *',[ animate('300ms ease-in-out')]),
      transition('* => void',[ animate('300ms ease-in-out')]),
    ]),
    trigger(
      'item', [
        transition(':enter', [
          style({height: 0, transform: 'scale(0)', opacity: 0}),
          animate('300ms', style({height: '*', transform: 'scale(1)', opacity: 1}))
        ]),
        transition(':leave', [
          style({height: '*', transform: 'scale(1)', opacity: 1}),
          animate('100ms', style({height: 0, transform: 'scale(0)', opacity: 0}))
        ])
      ])
    
  ]
})
export class SingleMessageComponent implements OnInit, OnDestroy {
  @Input() conversationSubject: Observable<ConversationMeta>;
  @Output() openProfile: EventEmitter<string> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() uid: string;
  @Input() orgId: string;
  @Input() entityId: string;
  @Input() authLevel: string;
  currentState = 'void';

  conversation;
  profile: Profile;
  profileSubject;
  meta: ConversationMeta;
  metaRef: AngularFirestoreDocument<ConversationMeta>;
  metaSub: Subscription;
  messageToSend: string = '';
  autoRepliesTrigger = 'void'
  participants;
  participantsSubscription: Subscription;
  members;
  confirmationButtons = 'void'
  claimButton = 'void';
  rightButtonEnable = 'void'
  closed = true;
  scrolledOnEnter = false
  scrollTimer;
  messagesRef: AngularFirestoreCollection<Message>;
  messageSending = false;
  profiles = []
  autoReplies = []
  filteredAutoReplies = []
  leaving = new Subject()
  filter = "";
  config;
  questionPreviewExpanded = false;
  questionPreviewLoading = false;
  questionPreviewLessonId: string = null;
  questionPreviewQuestionId: string = null;
  questionPreviewQuestion: Question = null;
  questionPreviewQuestionOrder: string[] = [];
  questionPreviewSupplements: Supplement[] = [];
  expandedPreviewSupplementIndex: number = null;

  constructor(private um: UserManager, 
    private db: AngularFireDatabase,
     private scroll: ScrollService,
      private afs: AngularFirestore,
      private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  get questionsRoot(): string {
    return this.config?.questionsRoot || 'Questions';
  }

  ngOnInit() {
    if(this.conversationSubject){
       this.um.getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe(profile => {
        this.profile = profile
        // console.log(profile)
        this.afs.collection(PROFILES)
          .doc(profile.uid)
          .collection(AUTOREPLIES)
          .snapshotChanges()
          .take(1)
          .subscribe(actions => {
            this.autoReplies = []
            this.filteredAutoReplies = []
            actions.forEach(action => {
              const key = action.payload.doc.id
              const data = action.payload.doc.data()
              const reply = {key, ...data}
              this.autoReplies.push(reply)
            })
            this.filteredAutoReplies = [...this.autoReplies]
        })
        this.checkRightButtonEnable()  
        if(this.meta && !this.closed){
          this.um.decrememntUnreadMessages(this.meta.key)    
        }
        
      })
      this.conversationSubject
      .takeUntil(this.leaving)
      .subscribe(conMeta => {
        // console.log(conMeta)
        if(conMeta){
          this.meta = conMeta
          this.resetQuestionPreview();

          this.metaRef = this.afs.collection<ConversationMeta>('Conversations').doc(`${conMeta.key}`)

          this.closed = false;
          if(!conMeta.lastMessage.read[this.profile.uid]){
            conMeta.lastMessage.read[this.profile.uid] = true
            this.metaRef.update(conMeta.lastMessage)
          }
          this.messagesRef = this.afs.collection<Message>('Conversations')
            .doc(`${conMeta.key}`)
            .collection('messages', ref => ref.orderBy('sortDate', 'desc'))
          this.conversation = this.messagesRef.valueChanges()
          this.metaSub =  this.conversation
          .takeUntil(this.leaving)
          .subscribe(conv => {
            this.um.decrememntUnreadMessages(conMeta.key)
            this.scrollToBottom()
          })
   
          // this.messagesRef.valueChanges().take(1).subscribe(() =>this.scrollOnEnter())
          this.getParticipants(conMeta)
          this.checkRightButtonEnable()

          // scroll to the bottom after some time...unfortunately scrolling on page load doesn't quite work here because the page is already loaded.
          this.scrollTimer = setInterval(() => {  this.scrollOnEnter()  }, 500 )

        }
      })
      
    }
  } 

  toggleAnswered(){
      this.metaRef.update({resolved: !this.meta.resolved})
      this.meta.resolved = !this.meta.resolved
  }

  toggleAutoReplyTrigger() {
    this.autoRepliesTrigger = this.autoRepliesTrigger === 'void' ? 'show': 'void'
    if(this.autoRepliesTrigger === 'show'){
      setTimeout(() => this.scrollToBottom(), 500)
    }
  }
  createNewAutoReply() {
    if(!this.profile) {return }
    if(this.messageToSend.trim() === ''){return}
    this.afs.collection(PROFILES)
    .doc(this.uid)
    .collection(AUTOREPLIES)
    .add({body: this.messageToSend})
    
    this.send()
}
  open(uid, e){
    
    if(this.profile && this.authLevel){
      e.stopPropagation()
      this.openProfile.emit(uid)
      
    }
    
  }
  ngOnDestroy(){
    // console.log('leaving')
    this.leaving.next()
  }
  scrollToBottom(){
    this.scroll.scrollVeriticalInContainer('#eMessageContainer','#messageBottom')
  }
  scrollOnEnter(){
    
    if(!this.scrolledOnEnter){
      this.scroll.scrollVeriticalInContainer('#eMessageContainer','#messageBottom')
      clearInterval(this.scrollTimer)
      this.scrolledOnEnter = true
    }
    
    return true
  }

  checkRightButtonEnable(){
    if(!this.profile){return}
    if(!this.authLevel || !this.meta){return}
    if( this.meta.instructor !== this.profile.uid && !this.closed){
      this.rightButtonEnable = 'show'
      this.claimButton = 'show'

      
    } else {
      this.claimButton = 'void'
      this.rightButtonEnable = 'void'
    }
  }

  claimButtonPress(){
    if(this.meta.instructor){
      this.presentClaimConfirmation()
    } else {
      this.claim()
    }
  }

  closeConvo() {
    this.participants = null
    this.closed = true
    this.checkRightButtonEnable()
    this.close.emit(null)
    this.meta = null
    this.metaRef = null
    this.messagesRef = null
    this.conversation = null
    this.scrolledOnEnter = false
    this.autoRepliesTrigger = 'void'
    this.resetQuestionPreview();
    if(this.metaSub){
      this.metaSub.unsubscribe()
    }
  }

  toComparableNumber(value: string): number {
    const n = Number(value);
    return Number.isFinite(n) ? n : NaN;
  }

  sortQuestionIds(ids: string[]): string[] {
    return [...ids].sort((a, b) => {
      const an = this.toComparableNumber(a);
      const bn = this.toComparableNumber(b);
      const aIsNum = !Number.isNaN(an);
      const bIsNum = !Number.isNaN(bn);
      if (aIsNum && bIsNum) {
        return an - bn;
      }
      if (aIsNum) {
        return -1;
      }
      if (bIsNum) {
        return 1;
      }
      return String(a).localeCompare(String(b));
    });
  }

  extractQuestionIdFromKey(key: string, lessonId: string): string {
    if (!key) {
      return null;
    }
    const prefix = `${lessonId}-`;
    if (!key.startsWith(prefix)) {
      return null;
    }
    const raw = key.slice(prefix.length);
    // Skip intro records like lesson-0; this preview is for real questions.
    if (raw === '0') {
      return null;
    }
    return raw;
  }

  loadQuestionOrderForLesson(lessonId: string): Promise<string[]> {
    return new Promise((resolve) => {
      this.db
        .list(`${this.questionsRoot}/${lessonId}`)
        .snapshotChanges()
        .take(1)
        .subscribe(
          (actions) => {
            const ids = actions
              .map((action) => this.extractQuestionIdFromKey(action.key, lessonId))
              .filter((id) => !!id);
            resolve(this.sortQuestionIds(ids));
          },
          () => resolve([])
        );
    });
  }

  loadQuestionPreviewQuestion(lessonId: string, questionId: string): Promise<Question> {
    return new Promise((resolve) => {
      this.db
        .object<Question>(`${this.questionsRoot}/${lessonId}/${lessonId}-${questionId}`)
        .valueChanges()
        .take(1)
        .subscribe(
          (question) => resolve(question || null),
          () => resolve(null)
        );
    });
  }

  loadQuestionPreviewSupplements(lessonId: string, questionId: string): Promise<Supplement[]> {
    return new Promise((resolve) => {
      this.db
        .list<Supplement>(`${this.questionsRoot}/${lessonId}/${lessonId}-${questionId}/Supplements`)
        .valueChanges()
        .take(1)
        .subscribe(
          (supplements) => resolve(supplements || []),
          () => resolve([])
        );
    });
  }

  async loadQuestionPreview(lessonId: string, questionId: string) {
    if (!lessonId || !questionId) {
      return;
    }
    this.questionPreviewLoading = true;
    this.questionPreviewLessonId = lessonId;
    this.questionPreviewQuestionId = questionId;

    const [order, question, supplements] = await Promise.all([
      this.loadQuestionOrderForLesson(lessonId),
      this.loadQuestionPreviewQuestion(lessonId, questionId),
      this.loadQuestionPreviewSupplements(lessonId, questionId),
    ]);

    this.questionPreviewQuestionOrder = order;
    this.questionPreviewQuestion = question;
    this.questionPreviewSupplements = supplements;
    this.expandedPreviewSupplementIndex = null;
    this.questionPreviewLoading = false;
  }

  getMetaLessonId(): string {
    if (!this.meta?.lessonID) {
      return null;
    }
    return String(this.meta.lessonID);
  }

  getMetaQuestionId(): string {
    if (!this.meta?.questionID) {
      return null;
    }
    return String(this.meta.questionID);
  }

  async toggleQuestionPreview() {
    if (!this.meta?.lessonID || !this.meta?.questionID) {
      return;
    }
    this.questionPreviewExpanded = !this.questionPreviewExpanded;
    if (!this.questionPreviewExpanded) {
      return;
    }
    await this.loadQuestionPreview(this.getMetaLessonId(), this.getMetaQuestionId());
  }

  hasQuestionPreviewContext(): boolean {
    return !!this.meta?.lessonID && !!this.meta?.questionID;
  }

  canNavigatePreviewPrevious(): boolean {
    const idx = this.questionPreviewQuestionOrder.indexOf(this.questionPreviewQuestionId);
    return idx > 0;
  }

  canNavigatePreviewNext(): boolean {
    const idx = this.questionPreviewQuestionOrder.indexOf(this.questionPreviewQuestionId);
    return idx >= 0 && idx < this.questionPreviewQuestionOrder.length - 1;
  }

  async previewPreviousQuestion() {
    if (!this.canNavigatePreviewPrevious()) {
      return;
    }
    const idx = this.questionPreviewQuestionOrder.indexOf(this.questionPreviewQuestionId);
    const prevId = this.questionPreviewQuestionOrder[idx - 1];
    await this.loadQuestionPreview(this.questionPreviewLessonId, prevId);
  }

  async previewNextQuestion() {
    if (!this.canNavigatePreviewNext()) {
      return;
    }
    const idx = this.questionPreviewQuestionOrder.indexOf(this.questionPreviewQuestionId);
    const nextId = this.questionPreviewQuestionOrder[idx + 1];
    await this.loadQuestionPreview(this.questionPreviewLessonId, nextId);
  }

  togglePreviewSupplement(index: number) {
    this.expandedPreviewSupplementIndex =
      this.expandedPreviewSupplementIndex === index ? null : index;
  }

  resetQuestionPreview() {
    this.questionPreviewExpanded = false;
    this.questionPreviewLoading = false;
    this.questionPreviewLessonId = null;
    this.questionPreviewQuestionId = null;
    this.questionPreviewQuestion = null;
    this.questionPreviewQuestionOrder = [];
    this.questionPreviewSupplements = [];
    this.expandedPreviewSupplementIndex = null;
  }
  getParticipants(meta: ConversationMeta){


    this.metaRef.collection('members').valueChanges()
     .takeUntil(this.leaving)
     .subscribe(members => {
       this.members = members
       Object.keys(this.members).forEach(key => {
         this.afs.doc(`${PROFILES}/${this.members[key].key}`)
         .valueChanges()
         .take(1)
         .subscribe(profile => {
           this.profiles.push(profile)
         })
       })
     })
 
 
   }
  presentClaimConfirmation(){
    this.claimButton = 'void'
  }
  presentClaimConfirmationEnd(e){
    if(e.toState = 'void' && e.fromState === 'show' && this.rightButtonEnable ==='show') {this.confirmationButtons = 'show'}
  }

  closeClaimConfirmation(){ 
    this.confirmationButtons = 'void'
  }
  closeClaimConfirmationEnd(e){
    if(e.toState === 'void' && e.fromState === 'show' ){
      
      this.checkRightButtonEnable()
    } 
    
  }

  claimIfNeeded() {
    if(!this.meta.instructor && this.authLevel){
      this.claim()
    }
  }
  claim(){
    if(this.meta && this.authLevel){
      //send message to old instructor that we are overriding him.

      //override instructor
      this.afs.collection(PROFILES)
      .doc(this.meta.creator)
      .update({instructor: this.profile.uid})
        
      const messagesRef = this.afs.collection<ConversationMeta>('Conversations')
      this.afs.collection<ConversationMeta>('Conversations', ref=> 
      ref.where('creator', '==', this.meta.creator)
      .where('instructor', '==', null)
      // .where('lastMessage.system', '==', false)
      .where('entityId', '==', `${this.profile.entityId}`)
      ).valueChanges()
      .take(1)
      .subscribe(messages => {
        messages.forEach(message => {
          message.instructor = this.profile.uid
          messagesRef.doc(message.key).update(message)
        })
      })    

      this.meta.instructor = this.profile.uid
      this.metaRef.update({
        'instructor' : this.profile.uid
      }).then(() =>{
          this.updateMembers()
          // this.um.assignMyselfAsInstructor(this.meta.creator)
          this.closeClaimConfirmation()
      })
    }
  }

  updateMembers(){
    if(!this.meta || !this.profile){ return }
    var member = {} as Member;
    member.key = this.profile.uid
    member.firstname = this.profile.firstname || "Unknown Individual"
    member.lastname = this.profile.lastname || ""
    this.metaRef.collection('members').doc(member.key).set(member)


  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter =  filterValue.trim().toLowerCase();
    if(this.filter === ""){
      this.filteredAutoReplies = [...this.autoReplies]
    } else {
      let results = _.filter(this.autoReplies, reply => {
        if(_.includes(String(reply?.body).toLowerCase(), this.filter.toLowerCase())){
          return true
        } else {
          return false
        }
      })
      // console.log(results)
      this.filteredAutoReplies = results
    }
    


  }


  chooseAutoReply(reply) {
    this.messageToSend = reply
    this.toggleAutoReplyTrigger()
  }

  async sendAndNotify(){
    // only applicable if you are an instructor.
    this.send()
    if(this.authLevel){
      try{

        // will throw if receiver doesn't have email notifications
        // enabled.
        let {firstname: name, email} = await this.getProfile(this.meta.creator);
        const notification = {} as EmailNotification;
        notification.instructor = this.profile.firstname // instructors first name
        notification.name = name; // users first name
        notification.to = email; // users email
        notification.last = new Date().getTime();
        this.db.object(`${NOTIFY}/${this.meta.creator}`).update(notification);
      } catch (e) {
        console.error(e);
      }
    }
  }

  async getProfile(uid: string): Promise<Profile> {
      const profile = await this.afs.doc<Profile>(`${PROFILES}/${uid}`)
        .valueChanges()
        .take(1)
        .toPromise();
      // check to make sure email notifications are not disabled
      if (!profile?.preferences?.notifications?.emailsEnabled) {
        return Promise.reject('Email Notification have been disabled by this user');
      } else {
        return profile;
      }
  }

  send(){
    if (this.messageSending) { return; }
    if (!this.messageToSend || !this.meta || !this.profile) {
      return
    }
    else {
      this.messageSending = true
      this.autoRepliesTrigger = 'void'
      const message = {} as Message
      message.profileEmail = this.profile.email || ""
      message.date = new Date().getTime()
      message.sortDate = 0 - new Date().getTime()
      message.message = this.messageToSend

      message.read = {}
      message.creator = this.profile.uid
      message.system = false
      message.read[`${this.profile.uid}`] = true
      if (this.profile.entityId) {
        message.entityId = this.profile.entityId 
      }
      //deprecated
      message.originalCreator = {firstname: this.profile.firstname, lastname: this.profile.lastname, key: this.profile.uid}
      // ^^

      this.claimIfNeeded() // claim if no one has claimed.
      this.updateMembers()
      message.profileName = this.profile.firstname || ""
      message.anonymous = this.profile.anonymous || false

      this.messagesRef.add(message).then(docRef =>{
        if(docRef){
          this.meta.lastMessage = {} as Message
          this.meta.lastMessage = message
          this.meta.latestUpdate = message.date
          this.metaRef.update({lastMessage: this.meta.lastMessage, latestUpdate: message.date})
          this.um.notifyMessageMembers(this.members, this.meta.key)
          this.scrollToBottom()
          this.messageToSend = ''
          this.messageSending = false
        } else {
          this.messageSending = false
        }
      }).catch(e => {console.error(e); this.messageSending = false})
    }
  }

}
